// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, getDataRequest, postDataRequest2, postloginRequest } from '@/utils/axios';
//旅游资源普查概况http://192.168.1.20:4522/zituSpace/actBusiness/overviewCensus
export const overviewCensus = params => {
  return getRequest('/actBusiness/overviewCensus', params);
};

//普查进度http://192.168.1.20:4522/zituSpace/actBusiness/zypucha
export const zypucha = params => {
  return getRequest('/actBusiness/zypucha', params);
};

//普查资源分类http://192.168.1.20:4522/zituSpace/actBusiness/dpczyfl
export const dpczyfl = params => {
  return getRequest('/actBusiness/dpczyfl', params);
};
//最新普查列表http://192.168.1.20:4522/zituSpace/actBusiness/newCensus
export const newCensus = params => {
  return getRequest('/actBusiness/newCensus', params);
};
// 资源普查进度趋势图 http://192.168.1.20:4522/zituSpace/tourismInfo/resourceChart
export const resourceChart = params => {
  return getRequest('/tourismInfo/resourceChart', params);
};
// http://192.168.1.20:4522/zituSpace/actBusiness/censusranking 进度比例排行
export const censusranking = params => {
  return getRequest('/actBusiness/censusranking', params);
};
// http://192.168.1.20:4522/zituSpace/actBusiness/censusesNumber
export const censusesNumber = params => {
  return getRequest('/actBusiness/censusesNumber', params);
};

// /zituSpace/es/productsEsPage
export const productsEsPage = params => {
  return getRequest('/es/productsEsPage', params);
};

// /zituSpace/censusProducts/getProductsXzqStatistics
export const getProductsXzqStatistics = params => {
  return getRequest('/censusProducts/getProductsXzqStatistics', params);
};

// /zituSpace/censusProducts/getProductsXzqStatistics
export const getProductsTypeStatistics = params => {
  return getRequest('/censusProducts/getProductsTypeStatistics', params);
};

// /zituSpace/censusProducts/getProductsXzqStatistics
export const getProductsYearStatistics = params => {
  return getRequest('/censusProducts/getProductsYearStatistics', params);
};

// /zituSpace/censusProducts/getProductsXzqStatistics
export const getProductsVisitsStatistics = params => {
  return getRequest('/censusProducts/getProductsVisitsStatistics', params);
};
// /zituSpace/censusProducts/findListZoningAndChildrenCensusProductsStatistics
export const findListZoningAndChildrenCensusProductsStatistics = params => {
  return getRequest('/censusProducts/findListZoningAndChildrenCensusProductsStatistics', params);
};

//文件是否有权限下载
///zituSpace/downloadApplication/download
export const download = (params,option) => {
  return getDataRequest('/downloadApplication/download', {params,option});
};

//新增文件申请
///zituSpace/downloadApplication/insertDownloadApplication
export const insertDownloadApplication = params => {
  return postloginRequest('/downloadApplication/insertDownloadApplication', params);
};


//文件预览下载链接
export const previewUrl = params => {
  return getRequest('/censusProducts/productPreview', params);
};

//单独的成果报告文件预览
export const achievementviewerUrl = params => {
  return getRequest('/censusProducts/resultsReportView', params);
};

//单独的成果报告文件下载
export const achievementdownloadUrl = params => {
  return getDataRequest('/censusProducts/resultsReportView', params);
};



export const ImageUrl = (id) => {
  return getRequest(`/censusProducts/productPDFPreview/${id}`);
};

//查询我的申请记录
export const findMyDownloadApplication = params => {
  return getRequest('/downloadApplication/findMyDownloadApplication', params);
};


export const saveOrder = params => {
  return postDataRequest2('/applicationForm/sava',params)
}

export const getOrder = () => {
  return getRequest('/applicationForm/findApplicationFormList')
}

export const deleteOrder = (id)=>{
  return getRequest(`/applicationForm/deleteByIds/${id}`)
}




// WEBPACK FOOTER //
// ./src/api/CensusProgress.js